import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/gift.svg")